export default __webpack_public_path__ + "30542be0b82468c32b94eced68cacfcf.jpg";